import { useEffect } from "react";
import TooltipUserNameheading from "../content-tooltip-username-heading";
import { getIdentifier } from "@/utils/helpers";
import { buildPlaySearchPath } from "@/constants/routes";

const TagHighlighter = ({
  selectedPostInModal,
  allUsersForTagging,
  currentUserFollowing,
  setCurrentUserFollowing,
}) => {
  // Event handlers
  const handleHashtagClick = (tag) => {
    console.log("Hashtag clicked:", tag);
    window.open(buildPlaySearchPath(tag.slice(1)), "_blank");
  };

  const handleUserTagClick = (tag) => {
    const findUser = allUsersForTagging.find(
      (user) => user?.username === tag.slice(1)
    );
    if (findUser && findUser?.id) {
      window.open(getIdentifier(findUser?.username, findUser?.id), "_blank");
    }
  };

  function highlightKeywordsWithClick(str, tags) {
    const elements = [];
    let lastIndex = 0;

    tags.forEach((tag) => {
      if (tag.startsWith("@") || tag.startsWith("#")) {
        const escapedTag = tag.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(`(${escapedTag})`, "g");
        let match;

        while ((match = regex.exec(str)) !== null) {
          // Text before the tag
          const beforeText = str.slice(lastIndex, match.index);
          if (beforeText) elements.push(beforeText);

          if (tag.startsWith("#")) {
            elements.push(
              <span
                key={`${match.index}-hashtag`}
                className="text-[#1e40af] cursor-pointer clickable-tag"
                data-tag="handleHashtagClick"
                data-value={match[0]}
              >
                {match[0]}
              </span>
            );
          } else if (tag.startsWith("@")) {
            elements.push(
              <TooltipUserNameheading
                key={`${match.index}-user`}
                username={match[0]}
                currentUserFollowing={currentUserFollowing}
                setCurrentUserFollowing={setCurrentUserFollowing}
              >
                <span
                  className="text-[#1e40af] cursor-pointer clickable-tag"
                  data-tag="handleUserTagClick"
                  data-value={match[0]}
                >
                  {match[0]}
                </span>
              </TooltipUserNameheading>
            );
          }
          // Update last index to continue after the current match
          lastIndex = regex.lastIndex;
        }
      }
    });

    // Add any remaining text after the last match
    if (lastIndex < str.length) {
      elements.push(str.slice(lastIndex));
    }

    return elements;
  }

  // Attach event listeners after rendering
  useEffect(() => {
    const clickableTags = document.querySelectorAll(".clickable-tag");
    const eventListeners = [];

    clickableTags.forEach((tagElement) => {
      const tagType = tagElement.getAttribute("data-tag");
      const tagValue = tagElement.getAttribute("data-value");

      if (tagType === "handleHashtagClick") {
        const handler = () => handleHashtagClick(tagValue);
        tagElement.addEventListener("click", handler);
        eventListeners.push({ element: tagElement, handler });
      } else if (tagType === "handleUserTagClick") {
        const handler = () => handleUserTagClick(tagValue);
        tagElement.addEventListener("click", handler);
        eventListeners.push({ element: tagElement, handler });
      }
    });

    // Clean up event listeners when the component unmounts
    return () => {
      eventListeners.forEach(({ element, handler }) => {
        element.removeEventListener("click", handler);
      });
    };
  }, [selectedPostInModal?.description, selectedPostInModal?.tags]);

  return (
    <pre className="text-light_primary_label dark:text-dark_primary_label leading-6 font-sans text-wrap break-words">
      {highlightKeywordsWithClick(
        selectedPostInModal?.description || "",
        selectedPostInModal?.tags || []
      )}
    </pre>
  );
};

export default TagHighlighter;
